import { AppRoutes } from "@router/router-helper";
import { useMatch } from "react-router-dom";
import { GroupTabs, MainRoutes, ProjectTabs } from "@router/route-params";

/** Identifier for the route match */

/**
 * A hook that matches the current route (pathname) with the provided paths
 * and returns the identifier of the matched route.
 */
import { HBDSettingRoute } from "@router/route-params";
export function useRouteMatch() {
  const matchProjectsRoute = useMatch(AppRoutes.ProjectsRoute);
  const matchAnalyticsRoute = useMatch(`${MainRoutes.app}/${MainRoutes.analytics}/*`);
  const matchProjectDetailsRoute = useMatch(AppRoutes.ProjectDetailsRoute);
  const matchMembersRoute = useMatch(AppRoutes.MembersRoute);
  const matchGroupsRoute = useMatch(AppRoutes.GroupsRoute);
  const matchGroupDetailsRoute = useMatch(AppRoutes.GroupsDetailsRoute);
  const matchWorkspacesRoute = useMatch(AppRoutes.WorkspaceSelectionRoute);
  const matchTeamsRoute = useMatch(AppRoutes.TeamRoute);
  const matchTeamOverviewRoute = useMatch(AppRoutes.TeamOverviewRoute);
  const matchAccountRoute = useMatch(AppRoutes.AccountSettingsRoute);
  const matchHBDSettingsRoute = useMatch(HBDSettingRoute);
  const matchSubscriptionExpiredRoute = useMatch(AppRoutes.subscriptionExpired);
  if (matchProjectsRoute) {
    return "projects";
  } else {
    if (matchAnalyticsRoute) {
      return "analytics";
    } else {
      if (matchProjectDetailsRoute && matchProjectDetailsRoute.params.projectTabs === ProjectTabs.snapshots) {
        return "snapshots";
      } else {
        if (matchProjectDetailsRoute && matchProjectDetailsRoute.params.projectTabs === ProjectTabs.members) {
          return "projectTeam";
        } else {
          if (matchProjectDetailsRoute) {
            return "projectDetails";
          } else {
            if (matchMembersRoute) {
              return "members";
            } else {
              if (matchGroupsRoute) {
                return "groups";
              } else {
                if (matchGroupDetailsRoute && matchGroupDetailsRoute.params.groupTabs === GroupTabs.managers) {
                  return "groupMembers";
                } else {
                  if (matchGroupDetailsRoute && (matchGroupDetailsRoute.params.groupTabs === GroupTabs.activeProjects || matchGroupDetailsRoute.params.groupTabs === GroupTabs.archivedProjects)) {
                    return "groupProjects";
                  } else {
                    if (matchWorkspacesRoute) {
                      return "workspaces";
                    } else {
                      if (matchTeamsRoute) {
                        return "teams";
                      } else {
                        if (matchTeamOverviewRoute) {
                          return "teamMembers";
                        } else {
                          if (matchAccountRoute) {
                            return "account";
                          } else {
                            if (matchHBDSettingsRoute) {
                              return "hbdSettings";
                            } else {
                              if (matchSubscriptionExpiredRoute) {
                                return "subscriptionExpired";
                              } else {
                                return "unknown";
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

/**
 * Returns true if the given route identifier is an account page (account settings or HBD settings)
 */
export function isAccountPageRoute(routeIdentifier) {
  return routeIdentifier === "account" || routeIdentifier === "hbdSettings";
}